export const contactDetailsQuestions: Record<string, any> = {
  email: {
    labelKey: 'applicationForm.CONTACT_DETAILS.email.label',
  },
  phoneNumber: {
    labelKey: 'applicationForm.CONTACT_DETAILS.phoneNumber.label',
  },
};
